<template>
    <slot v-bind="{
        ...state,
        setScroller,
    }" />
</template>

<script setup>
import { nextTick, onBeforeMount, reactive } from 'vue';

import { getPerson } from '../services/inventory';
import favorites from '../services/favorites';
import { initialiseScroller } from '../modules/scroller';

const state = reactive({
    isLoading: true,
    artists: [],
});

let scroller;

const setScroller = element => {
    scroller = element;
}

onBeforeMount(() => {
    const promises = favorites.getFavoriteArtists().map(artist => {
        return getPerson(artist);
    });

    Promise.all(promises).then(responses => {
        state.artists = responses;
    }).finally(() => {
        state.isLoading = false;

        nextTick(() => {
            if (scroller) {
                initialiseScroller(scroller);
            }
        });
    });
});
</script>
